import React from 'react';
import { Box, Typography, Button, Alert, Paper } from '@mui/material';
import { ErrorOutline as ErrorIcon, Refresh as RefreshIcon } from '@mui/icons-material';
import { useTenant } from '../contexts/TenantContext';

export const TenantErrorState: React.FC = () => {
  const { error, refreshTenants, loading } = useTenant();

  return (
    <Box
      sx={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        minHeight: '60vh',
        p: 3,
      }}
    >
      <Paper sx={{ p: 4, maxWidth: 500, textAlign: 'center' }}>
        <ErrorIcon sx={{ fontSize: 64, color: 'error.main', mb: 2 }} />

        <Typography variant="h5" gutterBottom>
          Tenant Configuration Error
        </Typography>

        <Typography variant="body1" color="text.secondary" sx={{ mb: 3 }}>
          {error || 'No tenants are available. Please contact your administrator.'}
        </Typography>

        <Alert severity="warning" sx={{ mb: 3, textAlign: 'left' }}>
          <Typography variant="body2">
            <strong>What this means:</strong>
            <br />
            • No tenant configurations were found
            <br />
            • You may not have access to any tenants
            <br />• The tenant service may be unavailable
          </Typography>
        </Alert>

        <Button
          variant="contained"
          startIcon={<RefreshIcon />}
          onClick={refreshTenants}
          disabled={loading}
          size="large"
        >
          {loading ? 'Refreshing...' : 'Try Again'}
        </Button>

        <Typography variant="caption" display="block" sx={{ mt: 2, color: 'text.secondary' }}>
          If this problem persists, please contact your system administrator.
        </Typography>
      </Paper>
    </Box>
  );
};
